import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/error.tsx");
